<template>
  <div class="row">
    <TextField
      v-model="activity.subject"
      name="subject"
      :label="__('common.subject')"
      class="col-md-7"
      required
    />

    <SelectField
      v-model="activity.priority"
      name="priority"
      :label="__('common.priority')"
      class="col-md-2"
      required
      :options="ActivityModel.priorities()"
    />

    <SelectField
      v-model="activity.type"
      name="type"
      :label="__('activities.form-activity-type')"
      class="col-md-3"
      required
      :options="ActivityModel.types()"
    />

    <TextAreaField
      v-model="activity.description"
      name="description"
      class="col-md-9"
      :label="__('common.description')"
      :rows="10"
    />

    <b-col md="3">
      <DateField
        v-model="activity.activityDate"
        name="activity_date"
        :label="__('activities.form-activity-date')"
        required
      />

      <SelectField
        v-model="activity.entityId"
        name="entity_id"
        :label="__('common.entity')"
        required
        :first-by-default="true"
        :options="activityEntities"
        @onChange="getActivityEntityResponsibleUsers"
      />

      <SelectField
        v-model="activity.userId"
        name="user_id"
        first-by-default
        :label="__('common.responsible')"
        required
        :options="activityUsers"
      />
    </b-col>

    <FormActions cols="12" :on-submit="save" :on-cancel="cancel" />
  </div>
</template>

<script>
import ActivityService from '@/Modules/Activity/ActivityService.js'
import EditFormMixin from '@/Modules/Activity/Mixins/EditFormMixin.js'
import { GET_AUTH_USER_ACTION } from '@/Modules/Auth/AuthModule.js'
import DatasetService from '@/Modules/Dataset/DatasetService.js'
import { mapActions } from 'vuex'

export default {
  mixins: [EditFormMixin],

  data() {
    return {
      activityEntities: [],
      activityUsers: [],
    }
  },

  watch: {
    'activity.entityId': {
      async handler(newValue) {
        await this.fetchActivityUsers(
          _.has(newValue, 'value') ? newValue.value : newValue
        )
      },
      deep: true,
    },
  },

  async created() {
    await this.fetchActivityEntities()
  },

  methods: {
    ...mapActions('AuthModule', {
      getUser: GET_AUTH_USER_ACTION,
    }),
    save() {
      if (this.activity.id) {
        if (this.handleUpdate) {
          this.handleUpdate(this.getActivityPayload(), () =>
            this.$emit('onSuccess', this.__('activities.form-update-success'))
          )
          return
        }

        ActivityService.update(this.activity.id, this.getActivityPayload())
          .then(() => {
            this.$emit('onSuccess', this.__('activities.form-update-success'))
          })
          .catch((error) => this.setErrorsFromResponse(error))

        return
      }

      if (this.handleCreate) {
        this.handleCreate(this.getActivityPayload(), () =>
          this.$emit('onSuccess', this.__('activities.form-create-success'))
        )
        return
      }

      ActivityService.create(this.getActivityPayload())
        .then(() => {
          this.$emit('onSuccess', this.__('activities.form-create-success'))
        })
        .catch((error) => this.setErrorsFromResponse(error))
    },
    async fetchActivityEntities() {
      this.activityEntities = await DatasetService.byTag('entitiesWithUsers')
      this.activity.entityId = this.authUser().entityId
    },
    async fetchActivityUsers(value) {
      this.activityUsers = await DatasetService.listOptionsByTagAndValue(
        'users',
        'entity_id',
        value
      )

      this.activity.userId =
        this.activityUsers.length && this.activityUsers.length > 0
          ? this.activityUsers[0].value
          : this.authUser().id
    },
  },
}
</script>
